// RecorderModalContext.js
import React, { createContext, useState, useContext } from "react";

const RecorderModalContext = createContext();

export const useRecorderModal = () => useContext(RecorderModalContext);

export const RecorderModalProvider = ({ children }) => {
  const [showRecorderModal, setShowRecorderModal] = useState(false);
  const [showTextModal, setShowTextModal] = useState(false);

  const openAudioModal = () => setShowRecorderModal(true);
  const closeAudioModal = () => setShowRecorderModal(false);
  const openTextModal = () => setShowTextModal(true);
  const closeTextModal = () => setShowTextModal(false);

  return (
    <RecorderModalContext.Provider value={{ showRecorderModal, openAudioModal, closeAudioModal, showTextModal, openTextModal, closeTextModal }}>
      {children}
    </RecorderModalContext.Provider>
  );
};
